import React, { useContext } from 'react';
import { ApolloError } from '@apollo/client';

import { IllustrationPremiumSpotWeb } from '@xingternal/illustrations';

import {
  InfoState,
  usePageContext,
  usePublishPageMutationMutation,
} from '@xingternal/pages-common';
import { ErrorContext } from '@xingternal/pages-page-error';
import * as Types from '@xingternal/pages-graphql-types';

import styles from './RepublishBanner.css';

const PageCreatedBanner = () => {
  const { showError } = useContext(ErrorContext);
  const { pageContext } = usePageContext();

  const [publishPage] = usePublishPageMutationMutation({
    onCompleted: (data) => {
      const errorType =
        data?.entityPageUpdatePublicationStatus?.error?.errorType;

      if (errorType) {
        showError({
          message: 'EP_GENERIC_FEEDBACK_ERROR',
          error: errorType,
        });
      } else {
        window.location.reload();
      }
    },
    onError: (error: ApolloError) => {
      showError({
        message: 'EP_GENERIC_FEEDBACK_ERROR',
        error: error?.message,
      });
    },
  });

  return (
    <InfoState
      icon={<IllustrationPremiumSpotWeb size="small" />}
      textCopyKey="EP_DRAFT_REPUBLISH_DESCRIPTION"
      className={styles.container}
      buttonProps={[
        {
          copyKey: 'EP_DRAFT_REPUBLISH_CTA',
          onClick: () =>
            publishPage({
              variables: {
                input: {
                  pageId: pageContext.pageId,
                  publicationStatus:
                    Types.EntityPagePublicationStatus.Published,
                },
              },
            }),
        },
      ]}
    />
  );
};

export default PageCreatedBanner;
